// Server bilan aloqa. URL va ochiq kalit maxfiy emas.
//
// Kirish tizimi (Q-021): brauzer — restoran qurilmasi (o'z Supabase hisobi, restoran logini bilan olinadi).
// Kassa ham, boshqaruv paneli ham shu BITTA klient orqali ishlaydi; panel chaqiruvlariga PIN bilan
// kirgan xodimning sessiyasi (p_session) avtomatik qo'shiladi.
//
// ONE POS yordami (Q-024): admin /yordam sahifasida o'z admin logini bilan kiradi. U alohida klient
// (sessionStorage — oyna yopilsa chiqadi) va qurilma hisobiga tegmaydi; xodim sessiyasi qo'shilmaydi.
import { OnePosClient } from '@onepos/client';
import { DEMO_URL } from '../demo/flag';
import { SESSION_RPC } from './sessionRpc';

// Demo sayt (demo.onepos.uz): server yo'q — so'rovlar brauzer ichidagi soxta serverga boradi (src/demo/server.mjs)
const IS_DEMO = import.meta.env.MODE === 'demo';
const demoFetch: typeof fetch | undefined =
  import.meta.env.MODE === 'demo' ? (input, init) => import('../demo/server.mjs').then((m) => m.demoFetch(input, init)) : undefined;

const URL = IS_DEMO ? DEMO_URL : import.meta.env.VITE_SUPABASE_URL || 'https://nfijlgvzhaamnbtpnkcg.supabase.co';
const KEY = IS_DEMO ? 'demo' : import.meta.env.VITE_SUPABASE_KEY || 'sb_publishable_E41UZoZJZWHQpIhUmIKHLg_zFrnF3CV';

export const deviceApi = new OnePosClient({
  url: URL,
  key: KEY,
  storageKey: IS_DEMO ? 'onepos.demo.session' : 'onepos.device.session',
  fetch: demoFetch,
});

function tabStorage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

export const supportApi = new OnePosClient({ url: URL, key: KEY, storageKey: 'onepos.support.session', storage: tabStorage(), fetch: demoFetch });

const SUPPORT_FLAG = 'onepos.support.mode';

/** Shu oyna ONE POS yordami rejimidami (/yordam orqali kirilgan) */
export function isSupportMode(): boolean {
  if (typeof location !== 'undefined' && location.pathname.startsWith('/yordam')) return true;
  try {
    return tabStorage()?.getItem(SUPPORT_FLAG) === '1';
  } catch {
    return false;
  }
}

export function setSupportMode(on: boolean): void {
  try {
    if (on) tabStorage()?.setItem(SUPPORT_FLAG, '1');
    else tabStorage()?.removeItem(SUPPORT_FLAG);
  } catch {
    /* saqlash yo'q — /yordam manzilida qoladi */
  }
}

let staffSession: string | null = null;

/** Kassa holati (store) PIN bilan kirgan xodim sessiyasini shu yerga beradi */
export function setStaffSession(session: string | null): void {
  staffSession = session;
}

export function currentStaffSession(): string | null {
  return staffSession;
}


function client(): OnePosClient {
  return isSupportMode() ? supportApi : deviceApi;
}

export const api = {
  rpc<T>(name: string, args: Record<string, unknown> = {}): Promise<T> {
    const c = client();
    const withSession =
      c === deviceApi && SESSION_RPC.test(name) && staffSession && !('p_session' in args) ? { ...args, p_session: staffSession } : args;
    return c.rpc<T>(name, withSession);
  },
  select<T>(path: string): Promise<T[]> {
    return client().select<T>(path);
  },
  invoke<T>(name: string, body: Record<string, unknown> = {}): Promise<T> {
    return client().invoke<T>(name, body);
  },
};
